import {
  Id,
  projectStatus,
  id,
  list,
  Identifiable,
  Project,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

type Response = {
  projects: Identifiable<LinkedProject>[];
};

function getProject(httpClient: HttpClient, linker: Linker) {
  return (projectId: Id) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/projects/get-filtered-and-sorted-list",
        method: HttpMethods.POST,
        data: {
          sortType: "name",
          sortOrder: "ascending",
          zones: [],
          statuses: [],
          projects: [projectId],
          tags: [],
          options: { type: "details", size: 1, page: 0 },
        },
      })
      .then(({ projects }) =>
        projects && projects.length > 0 ? projects[0] : Promise.reject(),
      )
      .then(linker.linkProject)
      .then((project) => ({
        ...project,
        rootList: { ...list, ...project.activityRoot },
        isTemplate: project.isTemplate || project.template,
        status: project.status
          ? project.status
          : { ...projectStatus, uuid: id },
      }));
}

export { getProject };
